import { render, staticRenderFns } from "./QuestionFinish.vue?vue&type=template&id=5d3b53b8&scoped=true&"
import script from "./QuestionFinish.vue?vue&type=script&lang=js&"
export * from "./QuestionFinish.vue?vue&type=script&lang=js&"
import style0 from "./QuestionFinish.vue?vue&type=style&index=0&id=5d3b53b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3b53b8",
  null
  
)

export default component.exports